import { gql } from '@apollo/client';

export const GET_ACTIVITY_DASHBOARD = gql`
  query GetActivityDashboard($payload: ActivityDashboardPayload!) {
    getActivityDashboard(payload: $payload) {
      items {
        id
        companyId
        candidateId
        jobOrderId
        companyName
        candidateName
        jobOrder
        latestStage
        latestStageDate
        submissionStatus
        interviewRoundIndex
        interviewDateTime
        interviewTimeZone
        interviewTimeZoneId
        offerDate
        placementStatus
        placedDate
        placementId
        jobApplicantUpdatedAt
      }
      count
    }
  }
`;
